<template><!-- 对账结算记录 -->
  <el-card class="m-b" v-if="accountInfo">
    <div slot="header" class="clearfix">
      <span class="saas-card-header-name">对账结算记录</span>
    </div>
    <div class="content-detail">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item-account">
            <span class="title">对账结算单：</span>
            <span class="value_No" @click="skipAccoutPage">{{accountInfo.accountCode}}</span>
            <span class="account-status">{{getValue('reconciliationAndSettlementStatus', accountInfo.status)}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="common-item-account">
            <span class="title">最终结算金额(元)：</span>
            <div class="money-num">
              <p v-for="(item, index) in accountInfo.accountMoney" :key="index">
                <span class="money">{{_util.formatMoney(item.money)}}</span>
                <span>{{item.currencyCh}}</span>
                <span>/</span>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import { getValue } from '@/lib/enum'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      getValue,
      accountInfo: ''
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions([
      'getListAccountBySubOrderId',
      'getListAccountBySubOrderIdGys'
    ]),
    // 获取对账结算记录
    initData() {
      this[`${this.$store.state.system === 'purchaser'
        ? 'getListAccountBySubOrderId' : 'getListAccountBySubOrderIdGys'
      }`]({
        subOrderId: this.$route.query.id
      }).then(res => {
        if (res && res.length) {
          this.accountInfo = {
            accountCode: res[0].accountCode,
            accountMoney: res[0].accountMoney && JSON.parse(res[0].accountMoney),
            status: res[0].status,
            id: res[0].id
          }
        }
      })
    },
    // 跳至对账结算单详情页
    skipAccoutPage() {
      this.$router.push({
        name: `${this.$store.state.system === 'purchaser' ? 'reconciliationAndSettlementDetail' : 'SupplierReconciliationAndSettlementDetail'}`,
        query: { id: this.accountInfo.id, type: 'check' }
        // params: {
        //   isReLoad: true
        // }
      })
    }
  }
}
</script>
